import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  matchTakeStartToPreviousTake,
  selectActors,
  selectAllPropPresets,
  selectTakes3D,
} from "../../app/slices/TrainingSlice";
import Take3D from "../../models/Take3D";
import { getTakeStartMismatchMessages } from "./takeStartMismatchMessages";

/** Shown when a take doesn't start the way the take before it ends, or a prop is both placed and held. */
export default function TakeStartMismatchNotice({ take }: { take: Take3D }) {
  const dispatch = useDispatch();
  const takes = useSelector(selectTakes3D);
  const propPresets = useSelector(selectAllPropPresets);
  const actors = useSelector(selectActors);

  const messages = getTakeStartMismatchMessages(
    takes ?? [],
    take.id,
    propPresets ?? [],
    actors ?? [],
  );
  if (messages.length === 0) return null;

  return (
    <div
      role="note"
      data-testid="take-start-mismatch-notice"
      className="flex items-start gap-[8px] rounded-5 bg-[var(--pi-key-yellow-faded)] px-[10px] py-[8px]"
    >
      <WarningAmberOutlinedIcon
        className="mt-px flex-shrink-0 text-[var(--pi-key-yellow)]"
        sx={{ fontSize: 16 }}
      />
      <div className="flex min-w-0 flex-col gap-[6px] text-[13px] text-creator-text">
        {messages.map((message) => (
          <div key={message}>{message}</div>
        ))}
        <button
          type="button"
          data-testid="take-start-mismatch-fix"
          className="self-start font-medium text-creator-primary hover:underline"
          onClick={() => dispatch(matchTakeStartToPreviousTake(take.id))}
        >
          Fix take start
        </button>
      </div>
    </div>
  );
}
